import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import dragged, { removeMagnet } from './dragged/dragged.js'
import textarea from './textarea/textarea.js'
import create from './create/create.js'

export default contract({
  dragged: array([
    dragged
  ]),
  remove: array([
    removeMagnet
  ]),
  textarea: array([
    textarea
  ]),
  create: array([
    create
  ])
})
